import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyImport, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaNotesStore" */ './lazyIndex'),
    { name: 'OwaNotesStore' }
);

export const lazyGetNotesSDK: LazyImport<typeof lazyIndex.getNotesSDK, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getNotesSDK);

export const lazyCreateNoteFromMessageData: LazyAction<
    typeof lazyIndex.createNoteFromMessageData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createNoteFromMessageData);
export const lazySetRelatedSectionInNotesFeed: LazyAction<
    typeof lazyIndex.setRelatedSectionInNotesFeed,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setRelatedSectionInNotesFeed);
export const lazyCreateNewNote: LazyAction<typeof lazyIndex.createNewNote, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.createNewNote);
export const lazyDeleteNote: LazyAction<typeof lazyIndex.deleteNote, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.deleteNote);
export const lazyChangeNoteColor: LazyAction<typeof lazyIndex.changeNoteColor, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.changeNoteColor);
export const lazySyncNotes: LazyAction<typeof lazyIndex.syncNotes, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.syncNotes);
export const lazyViewEmailFromNote: LazyAction<
    typeof lazyIndex.viewEmailFromNote,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.viewEmailFromNote);
export const lazyHasEmailId: LazyImport<typeof lazyIndex.hasEmailId, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.hasEmailId);

export { default as getStore } from './store/store';
export { dispatchReadingPaneCurrentItem } from './mutators/dispatchReadingPaneCurrentItem';
